import { PurchaseOrderDetailDto, PurchaseOrderHeaderDto } from "src/dtos/purchaseOrder/purchaseOrderDto";
import { getFutureWeekdayExceptTodayAndTomorrow } from "src/utils/date/dateUtils";
import { formatDate } from "src/utils/string/stringUtil";

export interface PUR1030_R01Dto {
	purchaseOrderHeaderDto: PUR1030_R01HeaderDto;
	purchaseOrderDetailDtoList: PUR1030_R01DetailDto[];
}

export interface PUR1030_R01HeaderDto extends PurchaseOrderHeaderDto {

	post: string;
	address: string;
	otherAddress: string;

}

export const defaultPUR1030_R01HeaderDto: PUR1030_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	purchaseOrderNo: '',
	
	compCd: '',
	compNm: '',

	orderDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	vatType: '',
	totBaseVat: 'N',
	empNo: '',
	empNm: '',
	logicCenter: '',
	orderAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	moneyCd: '',
	dueDt: formatDate(getFutureWeekdayExceptTodayAndTomorrow()),
	telNo: '',
	faxNo: '',
	email: '',
	approveFlg: 'N',
	orderStatus: '',
	remark: '',

	post: '',
	address: '',
	otherAddress: '',
	
	inserted: false,
	isModified: false
}

// 구매주문 상세 DTO (단일 상속 방식)
export interface PUR1030_R01DetailDto extends PurchaseOrderDetailDto {

	completeTransport: number; // 출하완료 수량
	locationCd?: string;
	locationNm?: string;

}



export const defaultPUR1030_R01DetailDto: PUR1030_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	purchaseOrderNo: '',
	itemNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	modelNo: '',
	compCd: '',
	orderDt: formatDate(new Date()),
	customCd: '',
	itemSeq: 0,
	orderUnit: '',
	orderQty: 1,
	cancelQty: 0,
	orderPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
	remark: '',

	completeTransport: 0,

	inserted: false,	
	isModified: false
}
